import { onlyUnauthenticatedMiddleware } from "~/components/_refactored/auth";

export default onlyUnauthenticatedMiddleware;
